import * as S from "../TaskCardFirstSteps/taskCardContentsFirstSteps.styles";
import { ReactComponent as IconLeft } from "../../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconRight } from "../../../../styles/assets/svg/icon-right-arrow.svg";
import { ReactComponent as IconCamera } from "../../../../styles/assets/svg/icon-camera.svg";
import { ReactComponent as IconAlbum } from "../../../../styles/assets/svg/icon-album.svg";
import { ReactComponent as IconUploads } from "../../../../styles/assets/svg/icon-upload-gray.svg";
import { ReactComponent as IconCheckTrue } from "../../../../styles/assets/svg/icon-checkbox-check-primary.svg";
import { ReactComponent as IconCheckFalse } from "../../../../styles/assets/svg/icon-checkbox-none-gray.svg";
import { ReactComponent as IconCameraWhite } from "../../../../styles/assets/svg/icon-camera-white.svg";
import {
  Transportation,
  TransportationType,
} from "../../../../interface/transportation";
import dayjs from "dayjs";
import { useEffect } from "react";

interface TaskCardContentSecondProps {
  loadingCompletedData: TransportationType;
  handleNextButtonClick: () => void;
  handleBackBtnClick: () => void;
  setIsImgCheck: React.Dispatch<React.SetStateAction<boolean>>;
  setIsErrorCheck: React.Dispatch<React.SetStateAction<boolean>>;
  onImageRegisterPageMove: () => void;
  isImgCheck: boolean;
  isErrorCheck: boolean;
  isNextLevel: number;
  maxStep?: number;
}

const TaskCardContentsSecondSteps = ({
  loadingCompletedData,
  handleNextButtonClick,
  handleBackBtnClick,
  setIsImgCheck,
  setIsErrorCheck,
  onImageRegisterPageMove,
  isImgCheck,
  isErrorCheck,
  isNextLevel,
  maxStep = 6,
}: TaskCardContentSecondProps) => {
  useEffect(() => {
    if (loadingCompletedData) {
      setIsErrorCheck(loadingCompletedData.loading_point_completed || false);
      setIsImgCheck(loadingCompletedData.loading_point_img_completed || false);
    }
  }, [loadingCompletedData]);

  return (
    <S.TaskBox>
      <S.TaskTotalWrap onClick={onImageRegisterPageMove}>
        <IconCameraWhite width={25} height={25} /> 사진등록
      </S.TaskTotalWrap>
      <S.TaskContainer>
        <S.TaskContent>
          <S.TaskHeadBox>
            <S.Sbox>
              <S.StepBox>2 / {maxStep}단계</S.StepBox>
              <S.StateBox>상차완료</S.StateBox>
            </S.Sbox>
            <S.DateBox>
              {/* 변경 필요 */}
              {dayjs(new Date()).format("YYYY-MM-DD HH:mm")}
            </S.DateBox>
          </S.TaskHeadBox>
          <S.ProgressBar progress="39%" />
          {/* <S.PostImgBox>
          <S.CameraAlbumBox> */}
          {/* <S.PostCamera onClick={onClickCamera} function="camera">
              <IconCamera fill="lightgray" width={35} height={35} />
              <label>카메라</label>
              <input type="file" accept="image/*" capture="user" />
            </S.PostCamera> */}
          {/* <S.PostAlbum onClick={handleUploadImage}>
              <IconAlbum fill="white" width={35} height={35} />
              <label>앨범</label>
              <input
                ref={inputRef}
                type="file"
                accept="image/*"
                capture="environment"
                onChange={onChangeImg}
              />
            </S.PostAlbum> */}
          {/* <S.PostAlbum onClick={handleUploadImage}>
              <IconUploads width={35} height={35} />
              <label>이미지 업로드</label>
              <input
                id="imgFile"
                ref={inputRef}
                type="file"
                accept="image/*"
                onChange={onChangeImg}
              />
            </S.PostAlbum>
          </S.CameraAlbumBox>
          <S.PostImg onClick={onClickTModal}>
            <SliderImgCard
              transportationImages={transportationImages}
              imgUrl={imgUrl}
            />
          </S.PostImg>
        </S.PostImgBox> */}
          <S.CheckBoxGroup>
            <S.TaskCardCheckBox
              onClick={() => setIsImgCheck(!isImgCheck)}
              className={isImgCheck ? "checked" : ""}
              divGap="6px"
            >
              {isImgCheck ? (
                <IconCheckTrue width={25} height={25} />
              ) : (
                <IconCheckFalse width={25} height={25} />
              )}
              <p>필요한 사진 업로드를 완료했습니다.</p>
            </S.TaskCardCheckBox>
            <S.TaskCardCheckBox
              onClick={() => setIsErrorCheck(!isErrorCheck)}
              className={isErrorCheck ? "checked" : ""}
              divGap="6px"
            >
              {isErrorCheck ? (
                <IconCheckTrue width={25} height={25} />
              ) : (
                <IconCheckFalse width={25} height={25} />
              )}
              <p>컨테이너에 이상이 없습니다.</p>
            </S.TaskCardCheckBox>
          </S.CheckBoxGroup>
        </S.TaskContent>

        <S.ButtonBox>
          <S.Button width="60%" color="white" onClick={handleBackBtnClick}>
            <IconLeft width={20} height={20} />
            <S.BText>이전</S.BText>
          </S.Button>
          <S.Button
            width="100%"
            color="primary"
            onClick={handleNextButtonClick}
            isErrorCheck={isErrorCheck}
            disabled={!isErrorCheck}
          >
            <S.BText>다음</S.BText>
            <IconRight width={20} height={20} />
          </S.Button>
        </S.ButtonBox>
      </S.TaskContainer>
    </S.TaskBox>
  );
};

export default TaskCardContentsSecondSteps;
